import type {CopilotChatMessage} from '@github-ui/copilot-chat-types'
import {DownloadIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu} from '@primer/react'

import {ExportActionItem} from './ExportActionItem'

export interface ExportActionListProps {
  threadName: string
  threadId: string
  currentUserLogin: string
  messages: readonly CopilotChatMessage[]
  selectedThreadID: string | null
}

export function ExportActionList({
  threadName,
  threadId,
  currentUserLogin,
  messages,
  selectedThreadID,
}: ExportActionListProps) {
  const isCurrentlySelectedChat = selectedThreadID === threadId

  if (!isCurrentlySelectedChat) return null

  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <ActionList.Item>
          <ActionList.LeadingVisual>
            <DownloadIcon />
          </ActionList.LeadingVisual>
          Export
        </ActionList.Item>
      </ActionMenu.Anchor>
      <ActionMenu.Overlay>
        <ActionList>
          <ExportActionItem
            threadName={threadName}
            fileType="json"
            threadId={threadId}
            currentUserLogin={currentUserLogin}
            messages={messages}
          />
          <ExportActionItem
            threadName={threadName}
            fileType="md"
            threadId={threadId}
            currentUserLogin={currentUserLogin}
            messages={messages}
          />
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
